import { Button } from "@/components/ui/button";
import { LogOut, MapPin } from "lucide-react";

export function MobileNoLink({ onLogout }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-orange-50" data-testid="mobile-no-link">
      <MapPin className="w-16 h-16 text-orange-500 mb-4" />
      <h1 className="text-2xl font-bold mb-2">Conta não vinculada</h1>
      <p className="text-center text-muted-foreground mb-4">Seu usuário não está vinculado a nenhum entregador. Peça ao administrador para vincular sua conta.</p>
      <Button onClick={onLogout} variant="outline"><LogOut className="w-4 h-4 mr-2" />Sair</Button>
    </div>
  );
}
